interface ComparisonChartProps {
  rows: { current: string; sentinel: string }[];
  dark?: boolean;
}

export function ComparisonChart({ rows, dark }: ComparisonChartProps) {
  return (
    <div
      style={{
        borderRadius: "var(--radius-xl)",
        overflow: "hidden",
        border: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "var(--border)"}`,
        background: dark ? "rgba(255,255,255,0.02)" : "var(--surface)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          borderBottom: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "var(--border)"}`,
        }}
      >
        <div
          style={{
            padding: "1rem 1.5rem",
            fontWeight: 700,
            fontSize: "0.875rem",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            color: dark ? "var(--neutral-400)" : "var(--neutral-500)",
            background: dark ? "rgba(255,255,255,0.03)" : "var(--neutral-50)",
          }}
        >
          Current Safety
        </div>
        <div
          style={{
            padding: "1rem 1.5rem",
            fontWeight: 700,
            fontSize: "0.875rem",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            color: "var(--accent-400)",
            background: dark ? "rgba(61,220,151,0.05)" : "var(--accent-50)",
          }}
        >
          Sentinel Engineered Safety
        </div>
      </div>
      {rows.map((row, i) => (
        <div
          key={i}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            borderBottom:
              i < rows.length - 1
                ? `1px solid ${dark ? "rgba(255,255,255,0.06)" : "var(--border)"}`
                : "none",
          }}
        >
          <div
            style={{
              padding: "1rem 1.5rem",
              fontSize: "0.9375rem",
              color: dark ? "var(--neutral-400)" : "var(--neutral-600)",
              display: "flex",
              alignItems: "center",
              gap: "0.625rem",
            }}
          >
            <span style={{ color: "var(--error-500)", flexShrink: 0, fontSize: "1.125rem" }}>&#10007;</span>
            {row.current}
          </div>
          <div
            style={{
              padding: "1rem 1.5rem",
              fontSize: "0.9375rem",
              color: dark ? "var(--text-on-dark)" : "var(--text)",
              display: "flex",
              alignItems: "center",
              gap: "0.625rem",
              background: dark ? "rgba(61,220,151,0.03)" : "var(--accent-50)",
            }}
          >
            <span style={{ color: "var(--accent-500)", flexShrink: 0, fontSize: "1.125rem" }}>&#10003;</span>
            {row.sentinel}
          </div>
        </div>
      ))}
    </div>
  );
}
